export const viTranslations = {
  "scratch_card": {
    "preview_blocked": "Chế độ xem trước — không thể nhận thẻ.",
    "select_error": "Không thể nhận thẻ lúc này. Vui lòng thử lại.",
    "topup_error": "Không thể nạp lúc này. Vui lòng kiểm tra số điện thoại và thử lại.",
  },
  "common": {
    "loading": "Đang tải...",
    "check_product_info": "Kiểm tra thông tin sản phẩm",
    "not_found": "Không tìm thấy",
    "not_found_content": "Nội dung bạn tìm kiếm không tồn tại.",
    "error": "Lỗi",
    "back_to_home": "Về trang chủ",
    "all_rights_reserved": "Tất cả quyền được bảo lưu",
    "phone": "Điện thoại",
    "hotline": "Liên hệ hotline: {{phone}}",
    "email": "Email",
    "contact": "Liên hệ",
    "contact_info": "Thông tin liên hệ",
    "customer_info": "Thông tin khách hàng",
    "product_info": "Thông tin sản phẩm",
    "product_code": "Mã sản phẩm",
    "product_name": "Tên sản phẩm",
    "product_price": "Giá sản phẩm",
    "related_products": "Sản phẩm liên quan",
    "product_description": "Mô tả sản phẩm",
    "brand": "Thương hiệu",
    "category": "Danh mục",
    "verification_form": "Form xác thực",
    "verify": "Xác thực",
    "verification_product": "Xác thực sản phẩm",
    "verify_message": "Vui lòng nhập mã xác thực vào bên dưới. Sau đó ấn nút Xác Nhận để xác thực hàng hóa.",
    "note_verification": `<span class="text-[#B61212]">Lưu ý:</span> Nhập chính xác thông tin họ tên, SĐT để đảm bảo các quyền lợi về tích điểm, đổi quà và các vấn đề xác thực, khiếu nại liên quan.`,
    "distribution_info": "Thông tin phân phối",
    "agency_name": "Tên đại lý",
    "agency_address": "Địa chỉ đại lý",
    "agency_phone": "Điện thoại đại lý",
    "sales_date": "Ngày bán",
    "invoice_number": "Số hóa đơn",
    "services": "Dịch vụ",
    "verification_info": "Thông tin xác thực",
    "verification_code": "Mã xác thực",
    "status": "Trạng thái",
    "first_verification": "Lần xác thực đầu",
    "warranty_info": "Thông tin bảo hành",
    "has_warranty": "Có bảo hành",
    "warranty_period": "Thời gian bảo hành",
    "verified_localtion": "Vị trí xác thực",
    "verified": "Đã xác thực",
    "warranty_processing": "Đang xử lý bảo hành",
    "warranty_replaced": "Đã thay thế bảo hành",
    "remaining_days": "Số ngày bảo hành còn lại",
    "days": "ngày",
    "stamp_activated_content": "Tem đã được kích hoạt trước đó.",
    "unauthorized_access": "Truy cập trái phép",
    "unauthorized_content": "Bạn không có quyền truy cập vào nội dung này.",
    "congratulations": "Xin chúc mừng",
    "congratulations_content": "Bạn đã mua được sản phẩm PISEN chính hãng. Xin vui lòng điền thông tin để kích hoạt bảo hành PISEN Care Plus từ 2-6 tháng",
    "help_contact": "Mọi thắc mắc gửi về",
    "verification_date": "Ngày kích hoạt",
    "verify_code": "Mã xác thực",
    "customer_name": "Tên khách hàng",
    "phone_number": "Số điện thoại",
    
    "error_content": "Có lỗi đã xảy ra. Vui lòng kiểm tra lại mã xác thực hoặc liên hệ hotline để được tư vấn. Xin cảm ơn!",
    "limit_scan_content": "Số lượng quét vượt quá giới hạn. Vui lòng liên hệ hotline để được hỗ trợ",
    "stamp_warranty_replaced": "Sản phẩm đã được thay thế bảo hành.",
    "stamp_verified": "Sản phẩm đã được xác thực trước đó. Vui lòng kiểm tra lại hoặc liên hệ với người bán để được hỗ trợ!",
    "stamp_blocked_content": "Mã tem đang bị khoá. Vui lòng liên hệ hotline để được hỗ trợ.",
    "stamp_verify_success": "Chúc mừng bạn! Đây là sản phẩm chính hãng. Xin cảm ơn quý khách!",
    
    "stamp_new_title": 'Cảnh báo',
    "stamp_new_content": "Sản phẩm chưa được xuất kho. Vui lòng liên hệ hotline để được hỗ trợ.",
    "stamp_processing_content": "Sản phẩm đang đang trong quá trình xử lý. Vui lòng kiểm tra lại hoặc liên hệ với người bán để được hỗ trợ!",
    
    "stamp_cannot_access_scan_stamp_title": "Cảnh báo",
    "stamp_cannot_access_scan_stamp_content": "Sản phẩm không được phép xác thực trên ứng dụng landing page. Vui lòng kiểm tra lại hoặc liên hệ với người bán để được hỗ trợ!",
    "internal_notes": "Ghi chú nội bộ",
    "stamp_note": "Ghi chú tem"
  },
  "kichhoat": {
    "title": "Kích hoạt bảo hành sản phẩm",
    "enter_code": "Mã cào",
    "enter_code_placeholder": "Nhập mã cào...",
    "enter_serial": "Mã serial (barcode)",
    "enter_serial_placeholder": "Nhập serial...",
    "submit": "Kích hoạt bảo hành",
    "code_required": "Vui lòng nhập mã cào",
    "serial_required": "Vui lòng nhập serial",
    "congratulations": "Xin chúc mừng!",
    "congratulations_content": "Sản phẩm của bạn là hàng chính hãng. Vui lòng điền thông tin để kích hoạt bảo hành.",
    "customer_name": "Tên khách hàng",
    "phone_number": "Số điện thoại",
    "enter_name_placeholder": "Nhập tên khách hàng...",
    "enter_phone_placeholder": "Nhập số điện thoại...",
    "send_info": "Gửi thông tin",
    "product_name": "Tên sản phẩm",
    "warranty_days": "Thời gian bảo hành",
    "warranty_period": "Thời gian bắt đầu bảo hành",
    "remaining_days": "Số ngày bảo hành còn lại",
    "days": "ngày",
    "suspicious_title": "SẢN PHẨM CÓ DẤU HIỆU ĐÁNG NGỜ",
    "suspicious_content": "Vui lòng liên hệ với đại lý/nhà phân phối gần nhất để biết thêm chi tiết.",
    "name_required": "Vui lòng nhập tên khách hàng",
    "phone_required": "Vui lòng nhập số điện thoại",
    "phone_invalid": "Số điện thoại không đúng định dạng",
    "error": "Có lỗi xảy ra. Vui lòng kiểm tra lại thông tin hoặc liên hệ hotline."
  },
  "form": {
    "full_name": "Họ và tên",
    "phone_number": "Số điện thoại",
    "email": "Email",
    "address": "Địa chỉ",
    "enter_name": "Nhập họ và tên",
    "enter_phone": "Nhập số điện thoại",
    "enter_email": "Nhập email",
    "enter_address": "Nhập địa chỉ",
    "name_required": "Vui lòng nhập họ và tên",
    "phone_required": "Vui lòng nhập số điện thoại",
    "name_min_length": "Name must be at least {{min}} characters",
    "name_max_length": "Name cannot exceed {{max}} characters",
    "phone_invalid": "Số điện thoại không hợp lệ",
    "email_invalid": "Email không hợp lệ",
    "verification_code_required": "Vui lòng nhập mã xác thực",
  },
  "placeholders": {
    "verify_code": "Nhập mã xác thực",
    "customer_name": "Nhập tên khách hàng",
    "phone_number": "Nhập số điện thoại",
  },
  "buttons": {
    "verification": "Xác thực"
  },
  "warning": {
    "preview_mode": "Cảnh báo. Bạn đang ở chế độ preview, chúng tôi không cho phép xác thực mã.",
  },
  "error": {
    "verification_failed": "Verification failed. Please try again."
  },
  "stamp_status": {
    "checking": 'Đang kiểm tra',
    "new": 'Tem mới',
    "product_assigned": 'Đã gán sản phẩm',
    "processing": 'Đang xử lý',
    "sold": 'Đã bán',
    "warranty_processing": 'Đang xử lý bảo hành',
    "warranty_replaced": 'Đã thay bảo hành',
    "activated": 'Đã kích hoạt',
    "blocked": 'Đã bị chặn',
    "not_enough_stamp": 'Không đủ tem',
    "out_of_stamp": 'Hết tem',
    "over_limited": 'Đã kích hoạt',
  }
}
